// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ff287fab","239":"1e1d9330","455":"2e49a6d8"}[chunkId] + ".chunk.js";
};